import React from 'react';

const MarketCorrectionPage = () => {
  return (
    <>
      <div>MarketCorrectionPage</div>
    </>
  );
};

export default MarketCorrectionPage;
